/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Options from './Options';
import SensorResponse from './SensorResponse';

/**
* The SearchSensorsResponse model module.
* @module model/SearchSensorsResponse
* @version 2020-12-7
*/
export default class SearchSensorsResponse {
    /**
    * Constructs a new <code>SearchSensorsResponse</code>.
    * @alias module:model/SearchSensorsResponse
    * @class
    * @param sensors {Array.<module:model/SensorResponse>} センサー
    * @param result {module:model/SearchSensorsResponse.ResultEnum} 
    */

    constructor(sensors, result) {
        
        
        this['sensors'] = sensors;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>SearchSensorsResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SearchSensorsResponse} obj Optional instance to populate.
    * @return {module:model/SearchSensorsResponse} The populated <code>SearchSensorsResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchSensorsResponse();
                        
            
            if (data.hasOwnProperty('sensors')) {
                obj['sensors'] = ApiClient.convertToType(data['sensors'], [SensorResponse]);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * センサー
    * @member {Array.<module:model/SensorResponse>} sensors
    */
    'sensors' = undefined;
    /**
    * @member {module:model/SearchSensorsResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
